import { StateBase } from "./StateBase";
import { Spatial } from "../../geo/Spatial";
export class TraversingState extends StateBase {
    constructor(state) {
        super(state);
        this._adjustCameras();
        this._baseAlpha = this._alpha;
        this._speedCoefficient = 1;
        this._animationSpeed = 1 / 40;
    }
    append(nodes) {
        const emptyTrajectory = this._trajectory.length === 0;
        if (emptyTrajectory) {
            this._resetTransition();
        }
        super.append(nodes);
    }
    prepend(nodes) {
        const emptyTrajectory = this._trajectory.length === 0;
        if (emptyTrajectory) {
            this._resetTransition();
        }
        super.prepend(nodes);
    }
    set(nodes) {
        super.set(nodes);
        this._resetTransition();
    }
    setSpeed(speed) {
        this._speedCoefficient = Spatial.clamp(speed, 0, 10);
    }
    update(fps) {
        if (this._alpha === 1 && this._currentIndex + this._alpha < this._trajectory.length) {
            this._currentIndex += 1;
            this._setCurrent();
            this._resetTransition();
        }
        const animationSpeed = this._animationSpeed * (60 / fps);
        this._baseAlpha = Math.min(1, this._baseAlpha + this._speedCoefficient * animationSpeed);
        this._alpha = this._baseAlpha;
    }
    _getAlpha() {
        return Math.ceil(this._alpha);
    }
    _setCurrentCamera() {
        this._adjustCameras();
    }
    _adjustCameras() {
        if (this._previousNode == null) {
            return;
        }
    }
    _resetTransition() {
        this._alpha = 0;
        this._baseAlpha = 0;
    }
}
//# sourceMappingURL=TraversingState.js.map